/**
 * prescriptionTemplates — 병명별 처방 템플릿(테스트용). 카탈로그 시드 12종 약명 매핑 →
 * 모바일 OCR(difflib ≥0.6) 매칭 신뢰. 질병분류기호는 ICD 표기 차용(시스템엔 ICD 테이블 없음).
 */
export interface PrescItemT {
  name: string
  dose: number
  dailyCount: number
  durationDays: number
  slots: string // morning,lunch,dinner,bedtime
  instruction: string
}
export interface DiseaseT {
  key: string
  code: string // 질병분류기호(ICD)
  items: PrescItemT[]
}

export const SLOT_LABEL: Record<string, string> = {
  morning: '아침', lunch: '점심', dinner: '저녁', bedtime: '취침',
}

// 의료기관/처방의 고정 필러(사실감용).
export const CLINIC = {
  name: '마메내과의원',
  phone: '02-555-0100',
  fax: '02-555-0101',
  email: 'mame@clinic.kr',
  doctor: '김마메',
  license: '제 12345 호',
  orgCode: '12345678',
}

export const DISEASES: DiseaseT[] = [
  { key: '당뇨', code: 'E11', items: [
    { name: '메트포민서방정 500', dose: 1, dailyCount: 2, durationDays: 30, slots: 'morning,dinner', instruction: '아침·저녁 식후 30분' },
    { name: '아카보스 50', dose: 1, dailyCount: 3, durationDays: 30, slots: 'morning,lunch,dinner', instruction: '매 식사 직전' },
  ] },
  { key: '고혈압', code: 'I10', items: [
    { name: '아모잘탄정 5/50', dose: 1, dailyCount: 1, durationDays: 30, slots: 'morning', instruction: '아침 식후' },
    { name: '아스피린프로텍트', dose: 1, dailyCount: 1, durationDays: 30, slots: 'morning', instruction: '아침 식후' },
  ] },
  { key: '위염', code: 'K29', items: [
    { name: '판토록정 40mg', dose: 1, dailyCount: 1, durationDays: 28, slots: 'morning', instruction: '아침 식전 30분' },
  ] },
  { key: '고지혈증', code: 'E78.5', items: [
    { name: '리피토 10mg', dose: 1, dailyCount: 1, durationDays: 30, slots: 'bedtime', instruction: '취침 전' },
  ] },
  { key: '불면증', code: 'G47.0', items: [
    { name: '졸피드정 10mg', dose: 1, dailyCount: 1, durationDays: 14, slots: 'bedtime', instruction: '취침 직전' },
  ] },
  { key: '치매', code: 'F00', items: [
    { name: '도네페질정 5mg', dose: 1, dailyCount: 1, durationDays: 30, slots: 'bedtime', instruction: '취침 전' },
  ] },
  { key: '갑상선저하', code: 'E03.9', items: [
    { name: '신지로이드 100', dose: 1, dailyCount: 1, durationDays: 30, slots: 'morning', instruction: '아침 공복' },
  ] },
]

export const slotsKo = (slots: string): string =>
  slots.split(',').map((s) => SLOT_LABEL[s] ?? s).join('·')
